// extracted by mini-css-extract-plugin
module.exports = {"root":"Resume_root__SiyOP","title":"Resume_title__1wwDS","desc":"Resume_desc__wLyTg"};